"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.models = exports.providers = void 0;

var _UserProvider = require("./users/UserProvider");

var _AuthenticationProvider = require("./authentication/AuthenticationProvider");

var _SystemConfigProvider = require("./config/SystemConfigProvider");

var _LicenseProvider = require("./licensing/LicenseProvider");

var _user = require("./users/models/user");

var _role = require("./authentication/models/role");

var _kvp = require("./config/models/kvp");

var _license = require("./licensing/models/license");

var providers = {
  AuthenticationProvider: _AuthenticationProvider.AuthenticationProvider,
  UserProvider: _UserProvider.UserProvider,
  SystemConfigProvider: _SystemConfigProvider.SystemConfigProvider,
  LicenseProvider: _LicenseProvider.LicenseProvider
};
exports.providers = providers;
var models = {
  user: _user.userModel,
  role: _role.role,
  keyValuePairModel: _kvp.keyValuePairModel,
  license: _license.license
};
exports.models = models;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/index.js
// module id = 71
// module chunks = 0